var _defs, _g;

var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};

var SvgSkyline = function SvgSkyline(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '35px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '35px' : _ref$height,
      originalSize = _ref.originalSize,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      rest = _objectWithoutProperties(_ref, _excluded);

  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-19.4%",
    y: "-13.9%",
    width: "138.9%",
    height: "138.9%",
    filterUnits: "objectBoundingBox",
    id: "skyline_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.822463768 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "skyline_svg__b",
    d: "M155 5h36v36h-36z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-153 -3)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#skyline_svg__a)",
    xlinkHref: "#skyline_svg__b"
  }), /*#__PURE__*/React.createElement("image", {
    x: 155,
    y: 5,
    width: 36,
    height: 36,
    xlinkHref: "data:image/png;base64,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"
  }))));
};

export { SvgSkyline as ReactComponent };
export default "/_next/static/media/skyline.0dd89077.svg";